import React, { useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import withReducer from '@Hooks/withReducer';
import { withCombinedRouteParams } from '@AppRoutes/ConnectedRoute';
import RegisterReducer from './RegisterReducer';
import { registerReducerKey } from './RegisterConstants';
import Register from './Register';
import { setData, init, cancel, submit, resetState } from './RegisterActions';
import {
  ipAddress as ipAddressSelector,
  isLoading as isLoadingSelector,
  data as dataSelector,
  isAnonymousUser as isAnonymousUserSelector,
  isShibboleth as isShibbolethSelector,
  registerFail as registerFailSelector,
} from './RegisterSelectors';

function RegisterContainer(props) {
  useEffect(() => {
    // eslint-disable-next-line consistent-return
    const fetchData = async () => {
      const data = await Register.getData();
      if (data.bulkId && data.bulkPassword) {
        // setHasAccess(true);
        Promise.resolve();
      } else {
        // history.push('/access-denied'); // Redirect to an access denied page
      }
    };

    fetchData();
  }, []);
  return (
    <div>
      <Register {...props} />
    </div>
  );
}

const mapStateToProps = (state) => ({
  ipAddress: ipAddressSelector(state),
  isLoading: isLoadingSelector(state),
  data: dataSelector(state),
  isAnonymousUser: isAnonymousUserSelector(state),
  isShibboleth: isShibbolethSelector(state),
  registerFail: registerFailSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  setData: (data) => dispatch(setData(data)),
  init: () => dispatch(init()),
  cancel: () => dispatch(cancel()),
  submit: () => dispatch(submit()),
  resetState: () => dispatch(resetState()),
});

export default compose(
  withCombinedRouteParams,
  withReducer(registerReducerKey, RegisterReducer, true),
  connect(mapStateToProps, mapDispatchToProps)
)(RegisterContainer);
